import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { exposeCases } from "@/mocks/exposes";

const categories = [
  {
    name: "金融骗局",
    icon: "ri-line-chart-line",
    desc: "假理财、资金盘、虚拟货币，识别一切「稳赚不赔」的糖衣炮弹。"
  },
  {
    name: "网络诈骗",
    icon: "ri-shield-cross-line",
    desc: "刷单返利、假客服退款、仿冒平台，看清线上话术的每一步。"
  },
  {
    name: "消费维权",
    icon: "ri-shopping-bag-3-line",
    desc: "预付卡跑路、虚假折扣、售后扯皮，先看清再决定要不要买。"
  },
  {
    name: "行业黑幕",
    icon: "ri-eye-off-line",
    desc: "会销话术、隐形收费、虚假宣传，还原被包装过的真相。"
  },
  {
    name: "职场陷阱",
    icon: "ri-briefcase-line",
    desc: "招聘收费、培训贷、虚假岗位，入职签字之前先过一遍。"
  }
];

export default function CategorySection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按风险类型查找你关心的内容"
          description="骗局看似千变万化，套路却高度重复。按分类进入，能更快找到与你处境相近的案例。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => {
            const count = exposeCases.filter(
              (item) => item.category === category.name
            ).length;
            return (
              <Link
                key={category.name}
                to={`/expose?category=${encodeURIComponent(category.name)}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${category.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                    {count} 条案例
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {category.name}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">
                  {category.desc}
                </p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-700">
                  进入分类
                  <i
                    className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </span>
              </Link>
            );
          })}

          <div className="flex flex-col justify-between rounded-lg bg-secondary-900 p-6 text-background-100">
            <div>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-compass-3-line text-xl" aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">
                不确定从哪看起？
              </h3>
              <p className="mt-3 text-sm leading-6 text-secondary-100">
                直接进入爆料广场，用关键词搜索，或按最新与热度浏览全部案例。
              </p>
            </div>
            <Link
              to="/expose"
              className="mt-5 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
            >
              浏览全部爆料
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}